export namespace NConstants {
  export type IconObject = { id: string; color: string; code: string };
  export type Icons = Array<IconObject>;
}
